const keysList = [
	{
		path: '/network/keys-list/list',
		name: 'network-keys-list',
		component: () => import('@/views/network/keys-list/list.vue'),
		meta: {
			roles: ['MGN,translator'],
			layout: 'content',
			module: 'MGN,projects-keys',
		},
	},
]

export default keysList
